var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.522,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    fill: "#F59E0B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.522,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    stroke: "#000",
    strokeWidth: 3.045
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.071 36.077h-2.785V14.923c0-.51-.196-1-.544-1.36A1.825 1.825 0 0033.429 13H18.57c-.492 0-.965.203-1.313.563-.348.36-.544.85-.544 1.36v21.154H13.93a.912.912 0 00-.657.282.979.979 0 00-.272.68c0 .255.098.499.272.68.174.18.41.281.657.281H38.07a.913.913 0 00.657-.282.979.979 0 00.272-.68c0-.255-.098-.5-.272-.68a.912.912 0 00-.657-.281zm-7.428 0H18.57V14.923h12.072v21.154zM26 25.98c0-.286.082-.564.235-.802.153-.237.37-.422.625-.53.254-.11.534-.139.805-.083.27.056.518.193.713.395.195.202.327.459.381.738.054.28.026.57-.08.834a1.433 1.433 0 01-.512.647 1.36 1.36 0 01-1.759-.18A1.468 1.468 0 0126 25.98z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/media/door.062a5a42.svg";
export { SvgDoor as ReactComponent };